<template>
  <div>
    <main class="manager_content_main">
      <div class="WorkM_MainArea">
        <b-container fluid>
          <div class="WorkM_WorkSummary">
            <!-- タイトル欄 -->
            <div class="WorkM_WorkSummaryTitleArea">
              <div class="TitleItem_TitleLabel"><b-icon icon="table" class="mr-2"></b-icon>集計表</div>
            </div>
            <!-- 検索条件 -->
            <div class="WorkM_WorkSummaryConditionArea">
              <div class="ConditionRow d-flex">
                <div class="ConditionEachArea w-100">
                  <div class="EachRow d-flex flex-wrap align-items-center">
                    <div class="d-flex align-items-center my-1">
                      <label class="labelTitle labelTitleWorkState pt-0 pl-3" style="text-align:right;width:100px;">月度</label>
                      <b-select :options="optionYear" v-model="selectYear" style="width: 85px"></b-select>
                      <label class="labelTitle pt-0 pl-2">年</label>
                      <b-select :options="optionMonth" v-model="selectMonth" style="width: 70px"></b-select>
                      <label class="labelTitle pt-0 pl-2 pr-0">月</label>
                    </div>
                    <div class="d-flex align-items-center my-1" style="margin-right:25px;">
                      <label class="labelTitle pt-0 pl-3" style="text-align:right;width:100px;">締日区分</label>
                      <b-select class="selectSectionPart" v-model="selectClosingDate" :options="optionClosingDate"></b-select>
                    </div>
                    <div class="d-flex align-items-center my-1" style="margin-right:25px;">
                      <label class="labelTitle pt-0 pl-3" style="text-align:right;width:100px;">就業状況</label>
                      <b-select class="selectSectionPart" v-model="selectOnlyWork" :options="optionOnlyWork"></b-select>
                    </div>
                    <div class="d-flex align-items-center my-1" style="margin-right:25px;">
                      <label class="labelTitle pt-0 pl-3" style="text-align:right;width:100px;">報告</label>
                      <b-select class="selectSectionPart" v-model="selectReportStatus" :options="optionReportStatus"></b-select>
                    </div>
                    <div class="d-flex align-items-center my-1" style="margin-right:25px;">
                      <label class="labelTitle pt-0 pl-3" style="text-align:right;width:100px;">警告</label>
                      <b-select class="selectSectionPart" v-model="selectWarnStatus" :options="optionWarnStatus"></b-select>
                    </div>
                    <div class="d-flex align-items-center my-1" style="margin-right:25px;">
                      <label class="labelTitle pt-0 pl-3" style="text-align:right;width:100px;">社員番号</label>
                      <b-input class="selectSectionPart" v-model="targetShainCd" :disabled="!canChangeUser" maxlength="10"></b-input>
                    </div>
                    <div class="d-flex align-items-center my-1">
                      <label class="labelTitle pt-0 pl-3" style="text-align:right;width:100px;">社員名</label>
                      <b-input class="selectSectionPart" v-model="targetShainName" :disabled="!canChangeUser" maxlength="16"></b-input>
                    </div>
                  </div>
                  <div class="EachRow d-flex flex-wrap align-items-center">
                    <div class="d-flex align-items-center my-1" style="margin-right:25px;">
                      <label class="labelTitle pt-0 pl-3" style="width:100px;">本社/支店</label>
                      <b-select class="selectSectionPart" 
                      :options="optionOffice_group" 
                      v-model="selectOffice" 
                      @change="getAttendanceListOffice()" 
                      :items="optionOffice" 
                      value-field="office_code" 
                      text-field="office_name"
                      ></b-select>
                    </div>
                    <div class="d-flex align-items-center my-1" style="margin-right:25px;">
                      <label class="labelTitle pt-0 pl-2" style="text-align:right;width:100px;">部</label>
                      <b-select 
                      class="selectSectionPart" 
                      :options="optionPart_group" 
                      v-model="selectPart" 
                      @change="getAttendanceListPart()" 
                      :items="optionPart" 
                      value-field="key" 
                      text-field="part_name"></b-select>
                    </div>
                    <div class="d-flex align-items-center my-1">
                      <label class="labelTitle pt-0 pl-2" style="text-align:right;width:100px;">課</label>
                      <b-select 
                      class="selectSectionPart" 
                      :options="optionSection_group" 
                      v-model="selectSection" 
                      @change="getAttendanceListSection()" 
                      :items="optionSection" 
                      value-field="key" 
                      text-field="section_name"
                      ></b-select>
                    </div>
                    <b-button variant="transparent" class="WorkM_ButtonTempSuccess ml-auto" @click="btnSearch">
                      検索
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
            <!-- 一覧 -->
            <div class="WorkSummaryListArea small">
              <div class="mt-4">
                  <b-table id="work-summary-table" class="WorkSummaryListTable" :items="workSummaryList"
                  :fields="workSummaryFields" responsive="sm" small sticky-header bordered striped selectable @row-clicked="selectItem"
                  :tbody-tr-class="rowClass">


                <template #cell(index)="data">
                  <div style="text-align:right">
                    <p>{{ data.index + 1 }}</p>
                  </div>
                </template>

                <template #head(departmentName)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>部</p>
                  </div>
                  <div>
                    <p>課</p>
                  </div>
                </template>
                <template #head(shainName)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>氏名</p>
                  </div>
                  <div>
                    <p>社員番号</p>
                  </div>
                </template>
                <template #head(isNotBacklog)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128); margin-top: -6px;">
                    <p>未提出</p>
                  </div>
                  <div style="border-bottom: 1px dashed rgb(128,128,128); margin-top: -3px; margin-bottom: -3px;">
                    <p>未確定</p>
                  </div>
                  <div style="margin-bottom: -6px;">
                    <p>未承認</p>
                  </div>
                </template>
                  <template #head(weekdayCount)>
                    <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>義務日数</p>
                  </div>
                  <div>
                    <p>欠勤日数</p>
                  </div>
                </template>
                <template #head(weekdayAttendanceDays)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>平日出勤日数</p>
                  </div>
                  <div>
                    <p>平日就業日数</p>
                  </div>
                </template>
                <template #head(overtimeWorkTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>時間外労働(月)</p>
                  </div>
                  <div>
                    <p>残業MAX</p>
                  </div>
                </template>
                <template #head(yealyOvertimeWorkTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>時間外労働(年)</p>
                  </div>
                  <div>
                    <p>残業MAX</p>
                  </div>
                </template>
                <template #head(weekdayOvertimeWorkTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>残業</p>
                  </div>
                  <div>
                    <p>(内)深夜</p>
                  </div>
                </template>
                <template #head(holidayAllowanceWorkTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>休日</p>
                  </div>
                  <div>
                    <p>(内)深夜</p>
                  </div>
                </template>
                <template #head(legalHolidayAllowanceWorkTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>公休</p>
                  </div>
                  <div>
                    <p>(内)深夜</p>
                  </div>
                </template>
                <template #head(lateLeaveEarlyTime)>
                  <div>
                    <p>他振</p>
                  </div>
                  <div>
                    <p>等</p>
                  </div>
                </template>
                <template #head(paidHolidayDays)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>有休</p>
                  </div>
                  <div>
                    <p>有休残</p>
                  </div>
                </template>
                <template #head(paidHolidayTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>時間有休</p>
                  </div>
                  <div>
                    <p>法定取得</p>
                  </div>
                </template>
                <template #head(holidayTransferWorkTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>休日(振替)</p>
                  </div>
                  <div>
                    <p>公休(振替)</p>
                  </div>
                </template>
                <template #head(substituteHolidayTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>振休</p>
                  </div>
                  <div>
                    <p>振休残</p>
                  </div>
                </template>


                <!--部/課-->
                <template #cell(departmentName)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128); text-align:left;">
                    <p v-if="!emptyCheck(data.item.departmentName)">{{ data.item.departmentName }}</p>
                  </div>
                  <div style=" text-align:left;">
                    <p v-if="!emptyCheck(data.item.sectionName)">{{ data.item.sectionName }}</p>
                  </div>
                </template>
                <!--氏名/社員番号-->
                <template #cell(shainName)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128); text-align:left;">
                    <p v-if="!emptyCheck(data.item.shainName)">{{ data.item.shainName }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.shainCd)">{{ data.item.shainCd }}</p>
                  </div>
                </template>
                <!--未提出/未確定/未承認-->
                <template #cell(isNotBacklog)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128); margin-top: -6px;">
                    <p v-if="data.item.isNotBacklog">あり</p>
                  </div>
                  <div style="border-bottom: 1px dashed rgb(128,128,128); margin-top: -3px; margin-bottom: -3px;">
                    <p v-if="data.item.isNotConfirm">あり</p>
                  </div>
                  <div style="margin-bottom: -6px;">
                    <p v-if="data.item.isNotApproval">あり</p>
                  </div>
                </template>
                <!--警告-->
                <template #cell(alertStatus)="data">
                  <div>
                    <p v-if="data.item.alertStatus == 1">警告</p>
                    <p v-else-if="data.item.alertStatus == 2">要指導</p>
                  </div>
                </template>
                <!--義務日数/欠勤日数-->
                <template #cell(weekdayCount)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="!emptyCheck(data.item.weekdayCount)">{{ data.item.weekdayCount }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.absenceDays)">{{ data.item.absenceDays }}</p>
                  </div>
                </template>
                <!--平日出勤日数/平日就業日数-->
                <template #cell(weekdayAttendanceDays)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="!emptyCheck(data.item.weekdayAttendanceDays)">{{ data.item.weekdayAttendanceDays }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.weekdayWorkingDays)">{{ data.item.weekdayWorkingDays }}</p>
                  </div>
                </template>
                <!--時間外労働/残業MAX-->
                <template #cell(overtimeWorkTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="data.item.overtimeWorkTime != null" class="overtime">{{ data.item.overtimeWorkTime }}</p>
                  </div>
                  <div>
                    <p v-if="data.item.overtimeWarningTime != null">{{ data.item.overtimeWarningTime }}</p>
                  </div>
                </template>
                <!--年間時間外労働/残業MAX-->
                <template #cell(yealyOvertimeWorkTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="data.item.yealyOvertimeWorkTime != null" class="overtime">{{ data.item.yealyOvertimeWorkTime }}</p>
                  </div>
                  <div>
                    <p v-if="data.item.yealyOvertimeWarningTime != null">{{ data.item.yealyOvertimeWarningTime }}</p>
                  </div>
                </template>
                <!--基準内-->
                <template #cell(weekdayOvertimeWorkTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="!emptyCheck(data.item.weekdayOvertimeWorkTime)">{{ data.item.weekdayOvertimeWorkTime }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.weekdayLateNightWorkTime)">{{ data.item.weekdayLateNightWorkTime }}</p>
                  </div>
                </template>
                <!--休日-->
                <template #cell(holidayAllowanceWorkTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="!emptyCheck(data.item.holidayAllowanceWorkTime)">{{ data.item.holidayAllowanceWorkTime }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.holidayAllowanceLateNightWorkTime)">{{ data.item.holidayAllowanceLateNightWorkTime }}</p>
                  </div>
                </template>
                <!--公休-->
                <template #cell(legalHolidayAllowanceWorkTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="!emptyCheck(data.item.legalHolidayAllowanceWorkTime)">{{ data.item.legalHolidayAllowanceWorkTime }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.legalHolidayAllowanceLateNightWorkTime)">{{ data.item.legalHolidayAllowanceLateNightWorkTime }}</p>
                  </div>
                </template>
                <!--有休/有休残-->
                <template #cell(paidHolidayDays)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128); display:flex; justify-content: center;">
                    <p class="pr-1" v-if="(data.item.paidHolidayDays) != null">{{ data.item.paidHolidayDays.toFixed(1) }}日</p>
                    <p v-if="(data.item.paidHolidayYearlyCount) != null">{{ "(" + data.item.paidHolidayYearlyCount.toFixed(1) + "日)" }}</p>
                  </div>
                  <div>
                    <p v-if="(data.item.remainPaidHolidayDays) != null">{{ data.item.remainPaidHolidayDays.toFixed(1) }}日</p>
                  </div>
                </template>
                <!--時間有休/法定取得-->
                <template #cell(paidHolidayTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128); display:flex; justify-content: center;">
                    <p class="pr-1" v-if="(data.item.paidHolidayTime) != null">{{ data.item.paidHolidayTime }}</p>
                    <p v-if="(data.item.maxPaidHolidayTime) != null">{{ "(" + data.item.maxPaidHolidayTime + ")" }}</p>
                  </div>
                  <div style="display:flex; justify-content: center;">
                    <p class="pr-1" v-if="(data.item.paidHolidayOverHalfCount) != null">{{ data.item.paidHolidayOverHalfCount }}回</p>
                    <p v-if="(data.item.maxPaidHolidayOverHalfCount) != null">{{ "(" + data.item.maxPaidHolidayOverHalfCount + "回)" }}</p>
                  </div>
                </template>
                <!--特休-->
                <template #cell(specialHolidayTime)="data">
                  <div style="display:flex; justify-content: center;">
                    <p class="pr-1" v-if="!emptyCheck(data.item.specialHolidayTime)">{{ data.item.specialHolidayTime }}</p>
                    <p v-if="!emptyCheck(data.item.specialHolidayDays)">{{ "(" + data.item.specialHolidayDays + "日)" }}</p>
                  </div>
                </template>
                <!--休日(振替)/公休(振替)-->
                <template #cell(holidayTransferWorkTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="!emptyCheck(data.item.holidayTransferWorkTime)">{{ data.item.holidayTransferWorkTime }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.legalHolidayTransferWorkTime)">{{ data.item.legalHolidayTransferWorkTime }}</p>
                  </div>
                </template>
                <!--振休/振休残-->
                <template #cell(substituteHolidayTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128); display: flex; justify-content: center;">
                    <p class="pr-1" v-if="!emptyCheck(data.item.substituteHolidayTime)">{{ data.item.substituteHolidayTime }}</p>
                    <p v-if="!emptyCheck(data.item.substituteHolidayDays)">{{ "(" + data.item.substituteHolidayDays + "日)" }}</p>
                  </div>
                  <div style="display: flex; justify-content: center;">
                    <p class="pr-1" v-if="!emptyCheck(data.item.remainSubstituteHolidayTime)">{{ data.item.remainSubstituteHolidayTime }}</p>
                    <p v-if="!emptyCheck(data.item.remainSubstituteHolidayDays)">{{ "(" + data.item.remainSubstituteHolidayDays + "日)" }}</p>
                  </div>
                </template>

                </b-table>

              </div>
            </div>
          </div>
        </b-container>
      </div>
    </main>
  </div>
</template>
<script>
import config from "../../const/config";
export default {
  name: "Manager_WorkSummary",
  data() {
    return {
      systemVersion: null,
      loginUserId: null,
      workSummaryFields: [
        {
          key: 'index',
          class: 'col_index',
          thClass: 'table-header',
          label: '#',
          sortable: false,
        },
        {
          key: 'officeName',
          class: 'col_officeName',
          thClass: 'table-header',
          label: '本店/支店',
          sortable: false,
        },
        {
          key: 'departmentName',
          class: 'col_departmentName',
          thClass: 'table-header',
          label: '部',
          sortable: false,
        },
        {
          key: 'shainName',
          class: 'col_shainName',
          thClass: 'table-header',
          label: '氏名(社員番号)',
          sortable: false,
        },
        {
          key: 'isNotBacklog',
          class: 'col_isNotBacklog',
          thClass: 'table-header',
          label: '未提出',
          sortable: false,
        },
        {
          key: 'alertStatus',
          class: 'col_alertStatus',
          thClass: 'table-header',
          label: '警告',
          sortable: false,
        },
        {
          key: 'weekdayCount',
          class: 'col_weekdayCount',
          thClass: 'table-header',
          label: '義務日数',
          sortable: false,
        },
        {
          key: 'weekdayAttendanceDays',
          class: 'col_weekdayAttendanceDays',
          thClass: 'table-header',
          label: '平日就業日数',
          sortable: false,
        },
        {
          key: 'overtimeWorkTime',
          class: 'col_ovetrtime_work_total_time',
          thClass: 'table-header',
          label: '時間外労働',
          sortable: false,
        },
        {
          key: 'yealyOvertimeWorkTime',
          class: 'col_yealy_ovetrtime_work_total_time',
          thClass: 'table-header',
          label: '時間外労働',
          sortable: false,
        },
        {
          key: 'weekdayRegularWorkTime',
          class: 'col_weekdayRegularWorkTime',
          thClass: 'table-header',
          label: '基準内',
          sortable: false,
        },
        {
          key: 'weekdayOvertimeWorkTime',
          class: 'col_weekdayOvertimeWorkTime',
          thClass: 'table-header',
          label: '残業',
          sortable: false,
        },
        {
          key: 'holidayAllowanceWorkTime',
          class: 'col_holidayAllowanceWorkTime',
          thClass: 'table-header',
          label: '休日',
          sortable: false,
        },
        {
          key: 'legalHolidayAllowanceWorkTime',
          class: 'col_legalHolidayAllowanceWorkTime',
          thClass: 'table-header',
          label: '公休',
          sortable: false,
        },
        {
          key: 'overtimeDisasterWorkTime',
          class: 'col_overtimeDisasterWorkTime',
          thClass: 'table-header',
          label: '災害対象',
          sortable: false,
        },
        {
          key: 'lateLeaveEarlyTime',
          class: 'col_lateLeaveEarlyTime',
          thClass: 'table-header',
          label: '他振等',
          sortable: false,
        },
        {
          key: 'paidHolidayDays',
          class: 'col_paidHolidayTime',
          thClass: 'table-header',
          label: '有休',
          sortable: false,
        },
        {
          key: 'paidHolidayTime',
          class: 'col_paidHolidayTime',
          thClass: 'table-header',
          label: '時間有休',
          sortable: false,
        },
        {
          key: 'specialHolidayTime',
          class: 'col_specialHolidayTime',
          thClass: 'table-header',
          label: '特休',
          sortable: false,
        },
        {
          key: 'holidayTransferWorkTime',
          class: 'col_holidayTransferWorkTime',
          thClass: 'table-header',
          label: '休日(振替)',
          sortable: false,
        },
        {
          key: 'substituteHolidayTime',
          class: 'col_substituteHolidayTime',
          thClass: 'table-header',
          label: '振休',
          sortable: false,
        },
      ],
      workSummaryList: [],
      // 締日区分
      selectClosingDate: null,
      optionClosingDate: [],
      // 就業中のみ
      selectOnlyWork: 0,
      optionOnlyWork: [
        {
          value: 0, text: '就業中のみ'
        },
        {
          value: 1, text: '休業/退職含む'
        },
      ],
      // 報告
      selectReportStatus: 0,
      optionReportStatus: [
        {
          value: 0, text: '(すべて)'
        },
        {
          value: 1, text: '未提出あり'
        },
        {
          value: 2, text: '未確定あり'
        },
        {
          value: 3, text: '未提出と未確定'
        },
      ],
      // 警告
      selectWarnStatus: 0,
      optionWarnStatus: [
        {
          value: 0, text: '(すべて)'
        },
        {
          value: 1, text: '警告あり'
        },
      ],
      // 本社/支店
      optionOffice: [],
      selectOffice: null,
      // 部
      optionPart: [],
      selectPart: { "office_code": null, "part_code": null },
      // 課
      optionSection: [],
      selectSection: { "office_code": null, "part_code": null, "section_code": null },
      // 年
      optionYear: [],
      // 月
      optionMonth: [
        { value: 1, text: "01" },
        { value: 2, text: "02" },
        { value: 3, text: "03" },
        { value: 4, text: "04" },
        { value: 5, text: "05" },
        { value: 6, text: "06" },
        { value: 7, text: "07" },
        { value: 8, text: "08" },
        { value: 9, text: "09" },
        { value: 10, text: "10" },
        { value: 11, text: "11" },
        { value: 12, text: "12" },
      ],
      selectYear:0,
      selectMonth:0,
      targetShainCd: null,
      targetShainName: null,
      canChangeUser: true,
    };
  },
  computed: {
    // 支店変更時に使用
    defaultPart: function(){
      return {"office_code":this.selectOffice, "part_code":null};
    },
    // 部署変更時に使用
    defaultSection: function(){
      return {"office_code":this.selectOffice, "part_code":this.selectPart.part_code, "section_code":null};
    },
    // 支店リスト
    optionOffice_group: function(){
      let arr = [];
      arr = arr.concat({"office_code":null, "office_name":"(すべて)"});
      if(this.optionOffice !== undefined){
        arr = arr.concat(this.optionOffice);
      }
      return arr;
    },
    // 部署リスト
    optionPart_group: function(){
        let arr = [];
        arr = arr.concat({"key":this.defaultPart, "part_name":"(すべて)"});
        if(this.optionPart !== undefined){
            if(this.selectOffice == null){
                arr = arr.concat(this.optionPart);
                return arr;
            }
            let partListByselectedOffice =  this.optionPart.filter((part)=>{
                return part.key.office_code===this.selectOffice
            });
            arr = arr.concat(partListByselectedOffice);
            console.debug(JSON.stringify(arr));
        }
        return arr;
    },
    // 課リスト
    optionSection_group: function(){
        let arr = [];
        arr = arr.concat({"key":this.defaultSection, "section_name":"(すべて)"});
        if(this.optionSection !== undefined){
            if(this.selectPart.office_code == null && this.selectPart.part_code == null){
                arr = arr.concat(this.optionSection);
                return arr;
            }
            let sectionListByselectedPart = this.optionSection.filter((section)=>{
                if(this.selectPart.part_code == null){
                    return section.key.office_code===this.selectOffice
                }
                else{
                    return section.key.office_code===this.selectPart.office_code && section.key.part_code===this.selectPart.part_code
                }
            });
            arr = arr.concat(sectionListByselectedPart);
        }
        return arr;
    }
  },
  watch: {},
  mounted: function () {
    this.systemVersion = this.$store.getters.getSystemVersion;
    this.loginUserId = this.$store.state.user_id;

    // 条件一覧取得
    this.getSearchConditionAPI();
  },
  methods: {

    //=======================================イベント処理

    // 行選択をすると勤務状況画面へ遷移する
    selectItem:function(item){
      console.log("item：" + JSON.stringify(item));
      const ROUTER_WORK_STATE = "/manager/WorkState";
      let targetInfo = {
        is_from_work_summary: true,
        target_user_cd: item.shainCd,
        target_user_name: item.shainName,
        target_year:this.selectYear,
        target_month:this.selectMonth
      }
      console.log("targetInfo：" + JSON.stringify(targetInfo));
      this.$store.commit("setWorkSummaryToWorkState", targetInfo);
      this.$router.push(ROUTER_WORK_STATE);
    },
    btnSearch: function(){
      this.btnSearchAPI();
    },
    // 本社/支店セレクトボックスを選択した時の動作
    getAttendanceListOffice: function(){
      this.selectPart = this.defaultPart;
      this.selectSection = this.defaultSection;
    },
    // 部セレクトボックスを選択した時の動作
    getAttendanceListPart:function(){
      this.selectSection = this.defaultSection;
    },

    //=======================================API呼出処理
    btnSearchAPI: function(){
      // 本社支店、部、課情報をセット
      let officeCode = null;
      let departmentCode = null;
      let sectionCode = null;
      officeCode = this.selectSection.office_code;
      departmentCode = this.selectSection.part_code;
      sectionCode = this.selectSection.section_code;
      if(this.emptyCheck(sectionCode) || sectionCode <= 0){
        officeCode = this.selectPart.office_code;
        departmentCode = this.selectPart.part_code;
      }
      if(this.emptyCheck(officeCode) || officeCode <= 0){
        departmentCode = this.selectOffice;
      }
      let paramList = {
          targetYear: this.selectYear,
          targetMonth: this.selectMonth,
          closedayType: this.selectClosingDate,
          employmentStatus: this.selectOnlyWork,
          shainCd: this.targetShainCd,
          shainName: this.targetShainName,
          officeCode: officeCode,
          departmentCode: departmentCode,
          sectionCode: sectionCode,
          searcherShainCd: this.loginUserId,
          reportStatus: this.selectReportStatus,
          warnStatus: this.selectWarnStatus,
      }
      console.debug(JSON.stringify(paramList));

      // 検索処理
      this.postData(config.URL.WORK_SUMMARY, paramList)
        .then((response) => {
          if(response.result){
            console.debug("response：" + JSON.stringify(response.container));
            this.setWorkSummaryInfo(response.container.eachStaffList);
          }
          else{
            this.showAlertError(response.message);
          }
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.error(e);
        })
        .finally(() => {});
    },

    getSearchConditionAPI: function(){
      let paramList = {
        shainCd: this.loginUserId,
      }
      let result = false;
      this.getWithParams(config.URL.WORK_SUMMARY, paramList)
          .then((response) => {
              console.info("response：" + JSON.stringify(response));
              // レスポンスの結果がfalseならエラーメッセージを表示
              if(!response.result){
                  this.showAlertError(config.MESSAGE.SERVER_ERROR);
                  return;
              }
              // 一覧表に結果をセット
              this.setIndex(response.container);
              result = true;
          })
          .catch((e) => {
              // Note: エラーメッセージは、共通処理で表示している
              console.error(e);
          })
          .finally(() => {
            // --- 検索処理実施 -> 成功時のみ
            if (result) {
              this.btnSearch();
            }
          });
    },

    //=======================================表操作処理

    setWorkSummaryInfo(items){
      this.workSummaryList = items;
    },
    setIndex(item){
      let standardYear = item.targetYear
      this.selectYear = standardYear;
      this.selectMonth = item.targetMonth;
      let optionClosingDateList = item.closedayTypeList;
      this.canChangeUser = item.canChangeUser;
      this.optionOffice = item.officeList;
      this.optionPart = item.partList;
      this.optionSection = item.sectionList;

      // 年一覧セット
      this.optionYear = [];
      let optionYear = 
        [
          {
            value: standardYear + 1,
            text: String(standardYear + 1)
          },
          {
            value: standardYear,
            text: String(standardYear)
          },
          {
            value: standardYear - 1,
            text: String(standardYear - 1)
          },
          {
            value: standardYear - 2,
            text: String(standardYear - 2)
          }
        ];
      this.optionYear = optionYear;
      // 締日区分一覧セット
      this.optionClosingDate = [];
      optionClosingDateList.forEach((item) => {
        let optionClosingDateItem = {
          value: item.code,text: item.name
        };
        this.optionClosingDate.push(optionClosingDateItem);
      });
    },
    rowClass(item, type) {
        let styleClass = "";
        if (!item || type !== 'row') return
        
        // 警告欄
        if (item.alertStatus == 1) {
          styleClass += " alert-row-1";
        } else if (item.alertStatus == 2) {
          styleClass += " alert-row-2";
        }

        // 時間外労働(月)
        if (item.monthAlertStatus == 1) {
          styleClass += " month-alert-row-1";
        } else if (item.monthAlertStatus == 2) {
          styleClass += " month-alert-row-2";
        }

        // 時間外労働(年)
        if (item.yealyAlertStatus == 1) {
          styleClass += " yealy-alert-row-1";
        } else if (item.yealyAlertStatus == 2) {
          styleClass += " yealy-alert-row-2";
        }

        return styleClass;
    },


    //=======================================チェック処理

    // 空文字かチェック
    // true: 空文字
    // false: 空文字ではない
    emptyCheck(text){
      if(text != null && text != ""){
        return false;
      }
      else{
        return true;
      }
    }
  }
};
</script>
<style>
.WorkM_WorkSummary {
  padding: 0 1rem;
}

.WorkM_WorkSummaryTitleArea {
  width: 100%;
  padding-bottom: 1rem;
}

.TitleItem_TitleLabel {
  width: 100%;
  text-align: center;
}

.WorkM_WorkSummaryConditionArea {
  padding: 1rem;
  border-top: 1px solid rgb(82, 75, 75);
  border-bottom: 1px solid rgb(82, 75, 75);
}

.WorkSummaryListArea {
  max-height: 620px;
  border-bottom: 1px solid rgb(212, 212, 212);
}

.WorkSummaryListTable {
  min-height: 9.5em;
  max-height: 50vh!important;
  overflow-x: auto;
  white-space: nowrap;
}
@media(min-width: 1870px){
  .WorkSummaryListTable {
    max-height: 57vh!important;
    overflow-x: auto;
    white-space: nowrap;
  }
}

.WorkSummaryListTable p{
  margin-top: auto;
  margin-bottom: auto;
}
#work-summary-table div{
  min-height: 24px;
}
#work-summary-table .table-sm th, .table-sm td {
  padding: 0.2rem !important;
}
#work-summary-table .col_index{
  min-width:50px;
  text-align: center !important;
}
#work-summary-table .col_departmentName {
  text-align: center;
}

#work-summary-table .col_shainName {
  text-align: center;
}

#work-summary-table .col_isNotBacklog {
  text-align: center;
}

#work-summary-table .col_shain_num_absence {
  min-width: 3.5em;
  text-align: right;
}

#work-summary-table .col_alertStatus {
  text-align: center;
  min-width: 65px!important;
}

#work-summary-table .alert-row-1 .col_alertStatus {
  background-color: #ff60ff;
  color:#ffff00;
  font-weight: bold;
}
#work-summary-table .alert-row-2 .col_alertStatus {
  background-color: red;
  color:#ffff00;
  font-weight: bold;
}

#work-summary-table .col_weekdayCount {
  text-align: center;
}

#work-summary-table .col_absenceDays {
  text-align: center;
}

#work-summary-table .col_weekdayAttendanceDays {
  text-align: center;
}

#work-summary-table .col_weekdayWorkingDays {
  text-align: center;
}

#work-summary-table .col_ovetrtime_work_total_time, #work-summary-table .col_yealy_ovetrtime_work_total_time {
  text-align: center;
}

#work-summary-table .month-alert-row-1 .col_ovetrtime_work_total_time .overtime {
  text-align: center;
  background-color: #ff60ff;
  color:#ffff00;
}
#work-summary-table .month-alert-row-2 .col_ovetrtime_work_total_time .overtime {
  text-align: center;
  background-color: red;
  color:#ffff00;
}
#work-summary-table .yealy-alert-row-1 .col_yealy_ovetrtime_work_total_time .overtime {
  text-align: center;
  background-color: #ff60ff;
  color:#ffff00;
}
#work-summary-table .yealy-alert-row-2 .col_yealy_ovetrtime_work_total_time .overtime {
  text-align: center;
  background-color: red;
  color:#ffff00;
}

#work-summary-table .col_weekdayRegularWorkTime {
  text-align: center;
}

#work-summary-table .col_weekdayOvertimeWorkTime {
  text-align: center;
}


#work-summary-table .col_weekdayLateNightWorkTime {
  text-align: center;
}

#work-summary-table .col_holidayAllowanceWorkTime {
  text-align: center;
}

#work-summary-table .col_holidayAllowanceLateNightWorkTime {
  text-align: center;
}

#work-summary-table .col_legalHolidayAllowanceWorkTime {
  text-align: center;
}

#work-summary-table .col_legalHolidayAllowanceLateNightWorkTime {
  text-align: center;
}

#work-summary-table .col_overtimeDisasterWorkTime {
  text-align: center;
}

#work-summary-table .col_overtimeWarningTime {
  text-align: center;
}

#work-summary-table .col_lateLeaveEarlyTime {
  text-align: center;
}

#work-summary-table .col_paidHolidayTime {
  text-align: center;
}

#work-summary-table .col_paidHolidayDays {
  text-align: center;
}

#work-summary-table .col_remainPaidHolidayTime {
  text-align: center;
}

#work-summary-table .col_specialHolidayTime {
  text-align: center;
}

#work-summary-table .col_specialHolidayDays {
  text-align: center;
}

#work-summary-table .col_holidayTransferWorkTime {
  text-align: center;
}

#work-summary-table .col_legalHolidayTransferWorkTime {
  text-align: center;
}

#work-summary-table .col_substituteHolidayTime {
  text-align: center;
}

#work-summary-table .col_substituteHolidayDays {
  text-align: center;
}

#work-summary-table .col_substitution_holiday_remain_time {
  text-align: center;
}
</style>
